var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plv-ia-load-error"},[_vm._v("\n  接口异常\n")])}
var staticRenderFns = []

export { render, staticRenderFns }